import React, { Fragment } from 'react';

const FrontCanvas = React.memo((props) => {
    if (props.item == null) {
        return null;
    }

    let frontImageUrl = null;
    let backImageUrl = null;
    if (props.language === 'English') {
        frontImageUrl = props.item.front_image_url_english;
        backImageUrl = props.item.back_image_url_english;
    } else if (props.language === 'Spanish') {
        frontImageUrl = props.item.front_image_url_spanish;
        backImageUrl = props.item.back_image_url_spanish;
    } else if (props.language === 'Chinese') {
        frontImageUrl = props.item.front_image_url_chinese;
        backImageUrl = props.item.back_image_url_chinese;
    } else if (props.language === 'Vietnamese') {
        frontImageUrl = props.item.front_image_url_vietnamese;
        backImageUrl = props.item.back_image_url_vietnamese;
    } else if (props.language === 'Arabic') {
        frontImageUrl = props.item.front_image_url_arabic;
        backImageUrl = props.item.back_image_url_arabic;
    }

    let frontLabel = null;
    let backContainer = null;
    if (backImageUrl && backImageUrl != null && backImageUrl !== '') {
        frontLabel = <h6>Front</h6>;
        backContainer = (
            <Fragment>
                <h6 className="mt-4">Back</h6>
                <div className="preview-image">
                    <img src={backImageUrl} alt="Apparel" />
                </div>
            </Fragment>
        );
    }

    let title = <h5>MyUTHealth Houston: {props.item.name}</h5>;
    let container = (
        <div className="horizontal-container">
            {frontLabel}
            <div className="preview-image front-preview">
                <img src={frontImageUrl} alt="Apparel" />
            </div>
            {backContainer}
        </div>
    );
    let penDescription = null;
    if (parseInt(props.item.id) === 3) {
        container = (
            <div className="vertical-container">
                <div>
                    <h6>Front</h6>
                    <div className="preview-image front-preview">
                        <img src={frontImageUrl} alt="Apparel" />
                    </div>
                </div>
                <div>
                    {backContainer}
                </div>
            </div>
        );
    } else if (parseInt(props.item.id) === 9) {
        title = <h5>My UTHealth Logo Pen: {props.item.name}</h5>;
        container = (
            <div className="vertical-container">
                <div>
                    {frontLabel}
                    <div className="preview-image pen-preview">
                        <img src={frontImageUrl} alt="Apparel" />
                    </div>
                </div>
                <div>
                    {backContainer}
                </div>
            </div>
        );
        penDescription = (
            <div className="pen-description">
                <h3>SLEEK WRITE RUBBERIZED PEN</h3>
                <h5>Silk Screen Imprint: 2" W x 1/2" H</h5>
                <div>Imprint Color: White and UTHealth Orange</div>
                <h5>Highlights:</h5>
                <div>Smooth writing Navy Blue pen.</div>
                <div>Plunger Action.</div>
                <div>Sleek Write Low Viscosity Ink.</div>
                <div>Smooth Rubberized Finish.</div>
                <div>In stock ready to ship.</div>
            </div>
        );
    } else if (parseInt(props.item.id) === 13) {
        title = (
            <h5 className="promo-card-title">
                UTHealth Houston Text Messaging Promo Card
                <br />
                (Epic Hello World)
            </h5>
        );
    }

    return (
        <div className="front-canvas-container">
            {title}
            <div className="language">Language: {props.language}</div>
            {container}
            {penDescription}
        </div>
    );
});

export default FrontCanvas;
